import AXIOS from "@/axios";
import { APIResponse } from "@/types/user.model";
import { TimeEntry, TimeEntryQuery, TimeEntryListResponse } from "@/types/time-entry.model";
import { removeEmptyProps } from "@/utils/constants";

export const createTimeEntryService = (payload: TimeEntry) => {
  return AXIOS.post<APIResponse<TimeEntry>>("/project/v1/time/create", payload);
};

export const updateTimeEntryService = (entryId: string, payload: any) => {
  return AXIOS.put<APIResponse<TimeEntry>>(
    `/project/v1/time/update/${entryId}`,
    payload
  );
};

export const deleteTimeEntryService = (entryId: string) => {
  return AXIOS.delete<{ message: string }>(
    `/project/v1/time/delete/${entryId}`
  );
};

export const getTimeEntryService = (entryId: string) => {
  return AXIOS.get<APIResponse<TimeEntry>>(`/project/v1/time/view/${entryId}`);
};

export const getAllTimeEntriesService = (query: TimeEntryQuery) => {
  return AXIOS.get<TimeEntryListResponse>("/project/v1/time/list", {
    params: removeEmptyProps(query),
  });
};

export const downloadTimeEntryPDFService = (
  type: "pdf" | "csv",
  params: TimeEntryQuery
) => {
  return AXIOS.get(`/project/v1/time/download/${type}`, {
    params: removeEmptyProps(params),
    responseType: "blob",
  });
};
